import { formatNumber } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { AppService, GRSSResponse } from 'src/app/_services/app.service';
import { DisplayDetailsComponent } from '../display-details/display-details.component';
import { MonitorComponent } from '../monitor.component';

@Component({
    selector: 'app-previous-contributions',
    templateUrl: './previous-contributions.component.html',
    styleUrls: ['./previous-contributions.component.css'],
    standalone: false
})
export class PreviousContributionsComponent implements OnInit {


  contribution: MarketContribution;
  marketId: string;
  marketCode: string;
  contRecordsLength: number = 0;
  transRecordsLength: number = 0;
  logsRecordsLength: number = 0;
  allowTransactions: boolean = false;
  allowSubmissions: boolean = false;
  isTransactional: boolean = false;

  isLoading: boolean = false;

  dataSource;
  displayColumns: string[] = ['contributed', 'contributor', 'approver'];
  displayColumnsDynamic: string[] = [];

  dataSourceTrans;
  displayColumnsTrans: string[] = ['contributed', 'instrumentCode', 'currency', 'status', 'cpSector', 'type', 'identifier', 'tradeDate', 'settlementDate', 'maturityDate', 'nominalAmount', 'rate', 'exchangeRate', 'forwardRate', 'level', 'levelSubmissionRate', 'anomalous', 'exclude'];

  dataSourceLogs;
  displayColumnsLogs: string[] = ['status', 'time', 'event', 'description'];
  transactionLogDetails: TransactionLogDetails;

  @ViewChild('sortCont', { static: false }) sortCont: MatSort;
  @ViewChild('sortTrans', { static: false }) sortTrans: MatSort;

  // tslint:disable-next-line: max-line-length
  constructor(private translate: TranslateService, private dialog: MatDialog, public service: AppService, public dialogRef: MatDialogRef<MonitorComponent>, @Inject(MAT_DIALOG_DATA) public data, private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  ngOnInit() {
    this.InitializeVariables();
    this.GetAccountContributions();
    this.CheckWindowOverride('submission');
    this.CheckWindowOverride('transaction');
  }

  /** Initializes the variables */
  InitializeVariables() {
    this.transactionLogDetails = {
      accepted: 0,
      corrupt: 0,
      invalid: 0,
      partial: 0,
      rejected: 0,
      logs: null
    };
    this.marketId = this.data.marketId;
    this.marketCode = this.data.marketCode;
    this.isTransactional = this.data.isTransactional;
    this.contribution = {
      status: this.data.contribution.status,
      matIcon: this.data.contribution.matIcon,
      matIconColor: this.data.contribution.matIconColor,
      contributor: this.data.contribution.contributor,
      contributorId: this.data.contribution.contributorId,
      noOfContributions: this.data.contribution.noOfContributions,
      instruments: this.data.contribution.instruments,
      relatedUserInfo: this.data.contribution.relatedUserInfo
    };
  }

  /** Fires when user clicks to change the contribution window override */
  CheckWindowOverride(type: string) {
    this.http.get<boolean>(this.baseUrl + 'api/monitorMarkets/checkWindowOpen/' + type + '/' + this.marketId + '/' + this.contribution.contributorId).subscribe(result => {
      if (type == 'transaction') {
        this.allowTransactions = result;
      } else if (type == 'submission') {
        this.allowSubmissions = result;
      }
    }, error => {
      console.error(error);
    });
  }

  /** Click event of the anomalous flag */
  OnClickAnomalous(anomalous: AnomalousModal) {
    if (anomalous.anomalous === true) {
      let message = '';
      if (anomalous.reasons.length > 0) {
        message = '<ul>';
        anomalous.reasons.forEach(reason => {
          message += '<li>' + reason + '</li>';
        });
        message += '</ul>';
      } else {
        message = '<i>No reasons to display.<i>';
      }

      this.service.SaveStatus(false, this.translate.instant('MarketMonitor.monitor.Messages.msgHeaderAnomalous'), message, true);
    }
  }

  /** Gets the previous contributions for the selected account */
  GetAccountContributions() {
    this.isLoading = true;
    this.http.post<MarketContributionPrevious>(this.baseUrl + 'api/monitorMarkets/getAccountContributions/' + this.marketId, this.contribution).subscribe(result => {
      this.contRecordsLength = result.contributions.length;

      if (this.displayColumnsDynamic.length === 0) {
        result.contributions.forEach(con => {
          con.instruments.forEach(ins => {
            if (this.displayColumnsDynamic.includes(ins.description) === false) {
              this.displayColumnsDynamic.push(ins.description);
            }
          });
        });
        this.displayColumns = this.displayColumns.concat(this.displayColumnsDynamic);
      }

      this.dataSource = new MatTableDataSource(result.contributions);
      this.dataSource.sort = this.sortCont;

      if (this.isTransactional === true) {
        this.transRecordsLength = result.transactions.length;
        this.dataSourceTrans = new MatTableDataSource(result.transactions);
        this.dataSourceTrans.sort = this.sortTrans;
        // Soluttion to activate sort on nested values
        this.dataSourceTrans.sortingDataAccessor = (item, property) => {
          if (property === 'anomalous') {
            return item[property][property];
          } else {
            return item[property];
          }
        };

        this.logsRecordsLength = result.logDetails.logs.length;
        this.dataSourceLogs = new MatTableDataSource(result.logDetails.logs);
        this.transactionLogDetails = result.logDetails;
      }

    }, error => {
      console.error(error);
    }, () => {
      this.isLoading = false;
    });
  }

  /** Cancel button event */
  OnCancel() {
    this.dialogRef.close();
  }

  /** Change event for the exclude checkboxes  */
  OnChangeExclude(trade: MarketContributionTransactionRecord, exclude: Exclude, event: any) {
    const isChecked: Boolean = event.checked;
    if (exclude.canEnableChkbx === true) {
      this.http.post<GRSSResponse>(this.baseUrl + 'api/monitorMarkets/changeExclude/' + isChecked, trade).subscribe(result => {

      }, error => {
        console.error(error);
      }, () => {
        this.GetAccountContributions();
      });
    }
  }

  /** Enable or disable transaction allow status in the database */
  EnableDisableTransactionAllow(type: string) {
    let isAllowed: boolean = false;
    if (type == 'transaction') {
      isAllowed = this.allowTransactions;
    } else if (type == 'submission') {
      isAllowed = this.allowSubmissions;
    }
    this.http.get<GRSSResponse>(this.baseUrl + 'api/monitorMarkets/changeWindowOverride/' + type + '/' + this.marketId + '/' + this.contribution.contributorId + '/' + isAllowed).subscribe(result => {
      if (result.statusCode === 4) {
        this.service.SaveStatus(true, 'MarketMonitor.monitor.Messages.msgHeaderAllowTrans', result.statusMessage);
      } else {
        // this.service.SaveStatus(false, 'MarketMonitor.monitor.Messages.msgHeaderAllowTrans', result.statusMessage);
      }
      this.CheckWindowOverride(type);
    }, error => {
      console.error(error);
    });
  }

  /**
   * A function to find the matching values
   * @param element
   * @param column
   * @param type
   */
  OnDataBound(element: MarketContribution, column: string): string {
    const currentLang = this.service.getLocalLanguage();
    let currentVal = element.instruments.find(o => o.description === column).value;
    if (!isNaN(Number(currentVal)) && currentVal !== '') {
      let temp: string = currentVal;
      if (temp.includes('.')) {
        temp = temp.replace('-', '');
        const beforeDec = temp.split('.')[0].length.toString();
        const afterDec = temp.split('.')[1].length.toString();
        currentVal = formatNumber(Number(currentVal), currentLang, beforeDec + '.' + afterDec + '-' + afterDec);
      } else {
        currentVal = formatNumber(Number(currentVal), currentLang);
      }
    }
    return currentVal;
  }

  /**
   * Format the specify number into the users locale.
   * @param value The value to format
   * @returns string containin hte formatted number
   */
  public FormatNumber(value: any) {
    const currentLang = this.service.getLocalLanguage();
    if (!isNaN(Number(value)) && value !== '') {
      value = new Intl.NumberFormat(currentLang).format(value);
    }
    return value;
  }

  /**
   * Function to display clicked name contact details
   * @param element Selected contact
   */
  OnClickName(element: MarketContribution) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.position = { top: '5%' };
    dialogConfig.data = {
      element: element,
      type: 'user',
      marketId: ''
    };
    this.dialog.open(DisplayDetailsComponent, dialogConfig);
  }

}

/**An interface to access market contribution record details */
interface MarketContribution {
  status: number;
  matIcon: string;
  matIconColor: string;
  contributor: string;
  contributorId: string;
  noOfContributions: number;
  instruments: MonitorInstrument[];
  relatedUserInfo: MarketContributionUser[];
}

/** Interface to access market contributor details */
interface MarketContributionUser {
  roleAs: number;
  username: string;
  loggedIn: boolean;
  organisationName: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  mobile: string;
}

/** An interface to access monitor instrument details */
interface MonitorInstrument {
  instrumentId: string;
  description: string;
  cssClass: string;
  value: string;
}

/** Interface to access market contributor detail record */
interface MarketContributionPreviousContributionRecord {
  contributed: string;
  contributor: MarketContributionUser;
  approver: MarketContributionUser;
  instruments: MonitorInstrument[];
}

/** Interface to access transaction details */
interface MarketContributionTransactionRecord {
  tradeId: string;
  instrumentCode: string;
  currency: string;
  status: string;
  cpSector: string;
  type: string;
  identifier: string;
  contributed: Date;
  tradeDate: Date;
  settlementDate: Date;
  maturityDate: Date;
  nominalAmount: number;
  rate: number;
  exchangeRate: number;
  forwardRate: number;
  level: number;
  levelSubmissionRate: string;
  anomalous: AnomalousModal;
  exOp1: Exclude;
  exOp2: Exclude;
}

/** Interface to access anomalous details */
interface AnomalousModal {
  anomalous: boolean;
  reasons: string[];
}

/** Interface to access transaction log details */
interface TransactionLogDetails {
  accepted: number;
  corrupt: number;
  invalid: number;
  partial: number;
  rejected: number;
  logs: TransactionLogRecord[];
}

/** Interface to access transaction logs of the organisation */
interface TransactionLogRecord {
  status: string;
  icon: string;
  event: string;
  description: string;
  time: string;
}

/** Interface to access the exclude status */
interface Exclude {
  userId: string;
  canEnableChkbx: boolean;
}

/** Interface to access the Previous records and transactions response */
interface MarketContributionPrevious {
  contributions: MarketContributionPreviousContributionRecord[];
  transactions: MarketContributionTransactionRecord[];
  logDetails: TransactionLogDetails;
}
